import React from "react";
import "./Header.css";

import { Link } from "react-router-dom"; //Link
import { useLocation } from "react-router-dom"; //useLocation
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import Form from 'react-bootstrap/Form';

import SearchIcon from "@mui/icons-material/Search";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";

import menuimg from "../assets/images/menuimg.png";
import flag from "../assets/images/flag.png";
import usa from "../assets/images/usa.png";
import singapore from "../assets/images/singapore.png";
import uae from "../assets/images/uae.png";
import logo1 from "../assets/images/logo1.png";


function Header() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  const [openMega, setOpenMega] = useState(false);
  const [openTextile, setOpenTextile] = useState(false);
  const [openLifestyle, setOpenLifestyle] = useState(false);

  /*modal*/
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  /*for sticky header*/
  const [sticky, setSticky] = useState(false);

  useEffect(() => {

  const handleScroll = () => {

    if (window.scrollY > 100) {
      setSticky(true);
    } else {
      setSticky(false);
    }

  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };

}, []);

  return (
    <>
      <header
        className={`
          header
          ${isHome ? "light" : "dark"}
          ${sticky ? "sticky_header" : ""}
        `}
      >
        <div className="main-header-outer">
          <div className="top-sale-alert-outer">
            <div className="container-fluid">
              <div class="top-sale-alert text-center" role="alert">
                <a href="#">
                  Free Shipping & Returns | Get 10% off on selected items
                </a>
              </div>
            </div>
          </div>

          <nav className="navbar navbar-expand-lg header-navbar">
            <div className="container-fluid">
              <div className="col-lg-5 col-md-5 col-sm-4 col-4">
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="">
                    <MenuOutlinedIcon />
                  </span>
                </button>
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <button
                    className="mobile-close-btn"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                  >
                    ✕
                  </button>
                  <ul className="navbar-nav">
                    <li className="nav-item  d-lg-none d-md-none d-sm-block">
                      <Link to="/">Home</Link>
                    </li>

                    {/* MEGA MENU START */}
                    <li className="mega-parent nav-item cr-dropdown-dekstop">
                      {/* <Link to="">
                        Carpets & Rugs
                        <KeyboardArrowDownIcon className="down_icon" />
                      </Link> */}

                      <div
                        className="mobile-dropdown-title"
                        onClick={() => setOpenMega(!openMega)}
                      >
                        <span>Carpets & Rugs</span>

                        <KeyboardArrowDownIcon
                          className={`down_icon ${openMega ? "rotate" : ""}`}
                        />
                      </div>

                      {/* DROPDOWN */}
                      <div
                        className={`mobile-dropdown-menu ${openMega ? "active" : ""}`}
                      >
                        <div className="mega-menu">
                          {/* COLUMN 1 */}
                          <div className="mega-column">
                            <h3>Shop By Size</h3>

                            <div className="size-grid">
                              <div className="inner_size">
                                <h4>Standard Rugs:</h4>

                                <ul>
                                  <li className="space-top">Small</li>
                                  <li>
                                    <Link to="/products">2' X 3'</Link>
                                  </li>
                                  <li>
                                    <Link to="/products">2.5' X 4'</Link>
                                  </li>
                                  <li>
                                    <Link to="/products">3' X 5'</Link>
                                  </li>

                                  <li className="space-top">Medium</li>
                                  <li>
                                    <Link to="/products">4' X 6'</Link>
                                  </li>
                                  <li>
                                    <Link to="/products">5' X 7'</Link>
                                  </li>
                                  <li>
                                    <Link to="/products">6' X 9'</Link>
                                  </li>

                                  <li className="space-top">Oversized</li>
                                  <li>
                                    <Link to="/products">10' X 14'</Link>
                                  </li>
                                  <li>
                                    <Link to="/products">12' X 15'</Link>
                                  </li>
                                  <li>
                                    <Link to="/products">12' X 18'</Link>
                                  </li>

                                  <li className="space-top">Large</li>
                                  <li>
                                    <Link to="/products">8' X 10'</Link>
                                  </li>
                                  <li>
                                    <Link to="/products">9' X 12'</Link>
                                  </li>
                                </ul>
                              </div>

                              <div className="inner_size">
                                <h4>Runners Rugs:</h4>
                                <ul>
                                  <li>
                                    <Link to="/products">2' X 6'</Link>
                                  </li>
                                  <li>
                                    <Link to="/products">2.5' X 8'</Link>
                                  </li>
                                  <li>
                                    <Link to="/products">2.5' X 10'</Link>
                                  </li>
                                  <li>
                                    <Link to="/products">2.5' X 12'</Link>
                                  </li>
                                  <li>
                                    <Link to="/products">2.5' X 15'</Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          {/* COLUMN 2 */}
                          <div className="mega-column">
                            <h3>Shop By Style</h3>

                            <ul>
                              <li>
                                <Link to="/products">Modern</Link>
                              </li>
                              <li>
                                <Link to="/products">Transitional</Link>
                              </li>
                              <li>
                                <Link to="/products">Traditional</Link>
                              </li>
                            </ul>

                            <h3 className="mt-40">Shop By Material</h3>

                            <ul>
                              <li>
                                <Link to="/products">Wool</Link>
                              </li>
                              <li>
                                <Link to="/products">Silk</Link>
                              </li>
                              <li>
                                <Link to="/products">Wool & Silk</Link>
                              </li>
                            </ul>
                          </div>

                          {/* COLUMN 3 IMAGE */}
                          <div className="mega-image">
                            <img src={menuimg} alt="Mega Menu" />
                          </div>
                        </div>
                      </div>
                    </li>
                    {/* MEGA MENU END */}

                    {/* SMALL DROPDOWN MENU */}
                    <li className="nav-item drop_menu_parent">
                      {/* <Link to="">
                        Home Textiles{" "}
                        <KeyboardArrowDownIcon className="down_icon" />
                      </Link> */}

                      <div
                        className="mobile-dropdown-title"
                        onClick={() => setOpenTextile(!openTextile)}
                      >
                        <span>Home Textiles</span>

                        <KeyboardArrowDownIcon
                          className={`down_icon ${openTextile ? "rotate" : ""}`}
                        />
                      </div>

                      <div
                        className={`short_menu ${openTextile ? "active" : ""}`}
                      >
                        <div className="drop_menu">
                          <ul>
                            <li>
                              <Link to="/products">Table Covers</Link>
                            </li>
                            <li>
                              <Link to="/products">Cushion Covers</Link>
                            </li>
                            <li>
                              <Link to="/products">Bedspreads</Link>
                            </li>
                            <li>
                              <Link to="/products">Quilts</Link>
                            </li>
                            <li>
                              <Link to="/products">Mat Sets</Link>
                            </li>
                            <li>
                              <Link to="/products">Throws</Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    {/* SMALL DROPDOWN MENU */}

                    {/* SMALL DROPDOWN MENU */}
                    <li className="nav-item drop_menu_parent">
                      {/* <Link to="">
                        Lifestyle Apparel{" "}
                        <KeyboardArrowDownIcon className="down_icon" />
                      </Link> */}

                      <div
                        className="mobile-dropdown-title"
                        onClick={() => setOpenLifestyle(!openLifestyle)}
                      >
                        <span>Lifestyle Apparel</span>

                        <KeyboardArrowDownIcon
                          className={`down_icon ${openLifestyle ? "rotate" : ""}`}
                        />
                      </div>

                      <div
                        className={`short_menu ${openLifestyle ? "active" : ""}`}
                      >
                        <div className="drop_menu">
                          <ul>
                            <li>
                              <Link to="/products">Night Suits (PJs)</Link>
                            </li>
                            <li>
                              <Link to="/products">Bathrobes</Link>
                            </li>
                            <li>
                              <Link to="/products">SCARFS Scarfs</Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    {/* SMALL DROPDOWN MENU */}

                    <li className="nav-item">
                      <Link to="/sale">Sale</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-2 col-sm-4 col-4">
                <div className="logo">
                  <Link to="/">
                  <img src={logo1} alt="" />
                  </Link>
                </div>
              </div>

              <div className="col-lg-5 col-sm-4 col-4">
                <div className="header-user-right">
                  <form className="search_form" role="search">
                    <input
                      className="form-control"
                      type="search"
                      aria-label="Search"
                    />
                    <button className="" type="submit">
                      <SearchIcon />
                    </button>
                  </form>
                  <div className="header-right-icons">
                    <SearchIcon className="search_icon" onClick={handleShow} />
                      <Link to="/cart"><LocalMallOutlinedIcon className="cart_icon" /></Link>
                      <Link to="/login"><PersonOutlinedIcon className="user_icon" /></Link>
                      <Link to="/cart" className="wishlist_icon_a"><FavoriteBorderIcon className="wishlist_icon" /></Link>
                  </div>

                  <div class="dropdown flag-dropdown">
                    <button
                      class="dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img src="/images/flag.png" alt="Hero" />
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a class="dropdown-item" href="#">
                          <img src={flag} alt="Hero" />
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="#">
                         
                          <img src={usa} alt="Hero" />
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="#">
                          <img src={singapore} alt="Hero" />
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="#">
                          <img src={uae} alt="Hero" />
                        </a>
                      </li>
                    </ul>

                     </div>

                </div>
              </div>
            </div>
          </nav>
        </div>

        <Modal show={show} onHide={handleClose} className="mobile_search_model">
          <Modal.Header closeButton>
            <h1>Search</h1>
          </Modal.Header>
          <Modal.Body>
            <form className="search_form" role="search">
              <input
                className="form-control"
                type="search"
                aria-label="Search"
              />
              <button className="" type="submit">
                <SearchIcon />
              </button>
            </form>
          </Modal.Body>
        </Modal>
      </header>
    </>
  );
}

export default Header;
